module.exports = require("vinyl");


//////////////////
// WEBPACK FOOTER
// external "vinyl"
// module id = 79
// module chunks = 0 1 2 3 4 5 6 7 10 11